import { useQuizList } from '@/views/build/components/useQuizList';
import { useBuildInfoContext } from '@/views/build/context';
import { useAiBuilderBuilderContext } from '../hooks';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { useAiBuilderChatActions } from '../stores';
import { type AiBuilderChatEntry } from '../stores/types';
import { type AiBuilderQuestionState, getAiBuilderQuestionState, getAiBuilderWelcomeSuggestions } from '../utils/aiBuilderWelcomePolicy';
import { AiBuilderActionChip } from './AiBuilderActionChip';
import { AiBuilderIntroMessage } from './AiBuilderIntroMessage';

/** 대화 시작 전 웰컴 화면 — 인트로 메시지 + 진입 의도별 추천 프롬프트 칩. */
export const AiBuilderWelcomeMessage = ({
  entryIntent,
  initialQuestionState
}: {
  entryIntent: AiBuilderChatEntry;
  initialQuestionState: AiBuilderQuestionState | null;
}) => {
  const builderContext = useAiBuilderBuilderContext();
  const copy = useAiBuilderChatCopy();
  const {
    action
  } = useBuildInfoContext();
  const {
    quizList
  } = useQuizList();
  const {
    submitPrompt
  } = useAiBuilderChatActions();
  const questionState = initialQuestionState ?? getAiBuilderQuestionState({
    action,
    questionCount: quizList.length
  });
  const welcomeSuggestions = getAiBuilderWelcomeSuggestions({
    builderContext,
    copy,
    entryIntent,
    questionState
  });
  return <div className="flex min-w-0 flex-col gap-none pb-md" data-sentry-component="AiBuilderWelcomeMessage" data-sentry-source-file="AiBuilderWelcomeMessage.tsx">
      <AiBuilderIntroMessage builderContext={builderContext} entryIntent={entryIntent} questionState={questionState} data-sentry-element="AiBuilderIntroMessage" data-sentry-source-file="AiBuilderWelcomeMessage.tsx" />

      <div className="flex min-w-0 max-w-full flex-col items-end gap-xs pl-3xl pr-lg">
        {welcomeSuggestions.map(suggestion => <AiBuilderActionChip key={suggestion.label} emoji={suggestion.emoji} label={suggestion.label} onClick={() => submitPrompt(suggestion.label, suggestion.turnHints ? {
        turnHints: suggestion.turnHints
      } : undefined)} />)}
      </div>
    </div>;
};